import React, { useContext } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { AuthContext } from "../context/auth";

export default function NavBar() {

  const { isTokenValid } = useContext(AuthContext);

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-transparent">
        <div className="container-fluid app-container navbar-cover">
          {/* Logo Start */}
          <Link to="/" className="navbar-brand">
            Hotelbnb
          </Link>
          {/* Logo End */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa-solid fa-bars custom-navbar-toggler-icon"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {/* NavBar Links Start */}
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-lg-3 gap-1 mt-lg-0 mt-3">
              <li className="nav-item">
                <NavLink to="/" className="nav-link" aria-current="page">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="book-now" className="nav-link" aria-current="page">
                  Book Now
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="support" className="nav-link" aria-current="page">
                  Support
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to={isTokenValid ? "my-account" : "login"} className="nav-link" aria-current="page">
                  My Account
                </NavLink>
              </li>
              {
                isTokenValid ? (
                  <li className="nav-item">
                    <NavLink to="logout" className="nav-link" aria-current="page">
                      Logout
                    </NavLink>
                  </li>
                ) : ( "" )
              }
            </ul>
            {/* NavBar Links End */}
          </div>
        </div>
      </nav>

      <Outlet />
    </>
  );
}
